import { PhoneNumberUtil } from "google-libphonenumber";
import HWLog from "./HWLog";
import HWLocalStorage from "./HWLocalStorage";

// Checks if an object is undefined or empty. A string is empty if it has only whitespaces.
export const isEmpty = (object) => {
    return (object === undefined) || (object === null) ||
        ((typeof object === 'string') && (object.trim() === "")) ||
        ((Array.isArray(object)) && (object.length === 0));
}

export const isNullOrUndefined = (object) => {
    return (object === undefined) || (object === null);
}

export const isAnyEmpty = (...objects) => {
    for (let object of objects) {
        if (isEmpty(object)) { return true; }
    }
    return false;
}

export const areAllEmpty = (...objects) => {
    for (let object of objects) {
        if (!isEmpty(object)) { return false; }
    }
    return true;
}

export const validateEmail = (emailId) => {
    if (!emailId) return false;
   return (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(emailId)) ? true : false;
}

export const validateName = (name) => {
    if (!name) return false;
   return (/^[a-zA-Z ]{2,30}$/.test(name)) ? true : false;
}

export const isValidPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return false;
    try {
        let phoneNumberString = phoneNumber.indexOf("+") === -1 ? ("+" + phoneNumber) : phoneNumber;
        let phoneNumberUtil = PhoneNumberUtil.getInstance();
        let number = phoneNumberUtil.parse(phoneNumberString);
        return phoneNumberUtil.isValidNumber(number);
    } catch(error) {
        console.log(error);
        return false;
    }
}

export const getUserLocation = () => {
    return Promise((resolve, reject) => {
         if (!navigator.geolocation) { reject("No Location Access:"); return; }
         navigator.geolocation.getCurrentPosition((onSuccessResult) => { resolve(onSuccessResult);   HWLog.info("SUCCESS LOCATION"); }, (onErrorResult) => { reject(onErrorResult);  HWLog.info("ERROR LOCATION")});
     })
 }

 export const dateByAdding = (numberOfDays) => {
    let date = new Date();
    date.setDate(date.getDate() + numberOfDays);
    return date;
}
export const returnDates=(date)=>{
    if(isNullOrUndefined(date))
    {
        
        return new Date()
    }
    else{
       
      console.log(date,"date here")
        return date;
    }
}

export const getUILogs = () => {
    return HWLocalStorage.load('user-logs')
}

export const saveUILogs = (data) => {
    const logs = getUILogs()
    if (!logs) 
        HWLocalStorage.save({ data: [data] }, 'user-logs')
    else 
        HWLocalStorage.save({ data: [ ...logs.data, data ] }, 'user-logs')
}
